export default __webpack_public_path__ + "static/media/user-profile-sample.071cfe64.png";